/*
 * Public API Surface of ngx-smart-modal
 */

export * from './lib/ngx-smart-modal';
